var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgForms = function SvgForms(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 29,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "forms_svg__a",
    width: 28,
    height: 29,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 .5h28v28H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#forms_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A8447",
    d: "M10.433 15.263h7.134a.85.85 0 0 0 .624-.252.85.85 0 0 0 .251-.624.85.85 0 0 0-.251-.623.85.85 0 0 0-.624-.252h-7.134a.85.85 0 0 0-.624.252.85.85 0 0 0-.251.624q0 .372.251.623a.85.85 0 0 0 .624.252m0 3.365h7.134a.85.85 0 0 0 .624-.252.85.85 0 0 0 .251-.623.85.85 0 0 0-.251-.624.85.85 0 0 0-.624-.25h-7.134a.85.85 0 0 0-.624.25.85.85 0 0 0-.251.624q0 .372.251.624a.85.85 0 0 0 .624.251m0 3.365h3.634a.85.85 0 0 0 .624-.251.85.85 0 0 0 .251-.624.85.85 0 0 0-.251-.623.85.85 0 0 0-.624-.252h-3.634a.85.85 0 0 0-.624.252.85.85 0 0 0-.251.624q0 .372.251.623a.85.85 0 0 0 .624.251m-3.074 3.59q-.884 0-1.497-.612a2.04 2.04 0 0 1-.612-1.497V5.526q0-.885.612-1.497a2.04 2.04 0 0 1 1.497-.612h8.393q.427 0 .814.163.386.165.674.451l4.895 4.896a2.1 2.1 0 0 1 .615 1.487v13.06q0 .884-.613 1.497a2.04 2.04 0 0 1-1.496.612zM21 10.417h-3.668q-.66 0-1.12-.462a1.53 1.53 0 0 1-.462-1.12V5.166H7.359a.34.34 0 0 0-.247.113.34.34 0 0 0-.112.247v17.948q0 .135.112.247a.34.34 0 0 0 .247.112h13.282q.135 0 .247-.112a.34.34 0 0 0 .112-.247z"
  }))));
};
export default SvgForms;